import { Injectable, NgZone } from "@angular/core";
import { Observable } from "rxjs";
import ApiEndpoint from "../ApiEndpoint";
import {HttpClient} from '@angular/common/http';
import { EventSourcePolyfill } from 'node_modules/event-source-polyfill/src/eventsource.js';

@Injectable({
  providedIn: "root"
})
export class SseService {
  constructor(private http: HttpClient, private _zone: NgZone,private httpClient: HttpClient) {}

  notifications:any[]=[]
  bellCount:number = null

  getNotificationsList() {
    return this.httpClient.get(`${ApiEndpoint.baseURL}/notification/all`);
  }

  seenNotifications(data) {
    return this.httpClient.post(`${ApiEndpoint.baseURL}/notification/change`,data);
  }

  getSSEMessages(): Observable<string> {

    let currentUser = localStorage.getItem('loginId')
    let sseUrl = `${ApiEndpoint.baseURL}/notification/subscription`;

    let headers = {
      headers : {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      heartbeatTimeout:18000000
    }

    return new Observable<string>(obs => {
      const es = new EventSourcePolyfill(sseUrl,headers);

      es.addEventListener(currentUser, (evt : any) => {
        obs.next(evt.data);
      });

      return () => es.close();
    });

  }

  setNotification(data:any){
    this.notifications = JSON.parse(data).concat(this.notifications)
    this.bellCount = this.notifications.filter(n=> n.status == 'Unseen' || n.status == 'New').length
  }

  pushNotification(data:any){
    this.notifications = JSON.parse(data).concat(this.notifications)
    this.bellCount ? this.bellCount++ : this.bellCount = 1
  }

  cloudflareTolerance(api:string, body:any, params='', newApi=false, serviceName=''){
    let generatedId = SseService.generateRandom();
    if(body instanceof FormData){
      body.append('generatedId', generatedId);
    } else {
      if(!body){
        body = {}
      }
      body.generatedId = generatedId
      params += `${params?'&':'?'}generatedId=${generatedId}`
    }
    this.http.post(api+params, body).subscribe();
    if(newApi){
      if(serviceName === 'fca'){
        api = `${ApiEndpoint.fcaURL}/heavy-requests`
      }else{
        api = `${ApiEndpoint.baseURL}/heavy-requests`
      }
    }
    api = api+'/subscribe/'+generatedId;
    let currentUser = localStorage.getItem('loginId')
    let headers = {
      headers : {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      heartbeatTimeout:18000000
    }
    return new Observable<string>(obs => {
      const es = new EventSourcePolyfill(api,headers);
      es.addEventListener(currentUser, (evt : any) => {
        let data = JSON.parse(evt.data);
        if(data.statusCode != 500){

          // console.log('-----------------------------------------------------------------------');
          // console.info(api);
          // console.info(body);
          // console.info(params);
          console.info(data);
          // console.info(newApi);

          obs.next(data);
          obs.complete()
        } else {
          console.error(data)
          obs.error();
          obs.complete()
        }
        es.close();
      });
      return () => es.close();
    });
  }

  private static generateRandom():string {
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < 8; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  cloudflareToleranceDownloadFile(api:string, body:any, params='', responseType='', serviceName=''){
    let generatedId = SseService.generateRandom();
    if(body instanceof FormData){
      body.append('generatedId', generatedId);
    } else {
      body.generatedId = generatedId
      params += `${params?'&':'?'}generatedId=${generatedId}`
    }
    this.http.post(api+params, body).subscribe();
    let currentUser = localStorage.getItem('loginId')
    let headers = {
      headers : {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      heartbeatTimeout:18000000
    }
    return new Observable<any>(obs => {
      let url=(serviceName==='fca')?`${ApiEndpoint.fcaURL}`:`${ApiEndpoint.baseURL}`;
      const es = new EventSourcePolyfill(url+`/heavy-requests/subscribe/${generatedId}`, headers);
      es.addEventListener(currentUser, (evt : any) => {
        // console.clear()
        let data = JSON.parse(evt.data);
        if(data.statusCode != 500){
          console.log(data)

          if(data.statusCode == 204 || data.statusCode == 404){
            obs.next(null)
            obs.complete()
          }else {
            let formData = new FormData();
            formData.append('id', data.result.id)
            formData.append('type', data.result.type)
            this.http.post(this.getDownloadEndPoint(data.result.server,serviceName), formData, {responseType:'blob'})
              .subscribe((res)=> {
                obs.next(res)
                obs.complete()
              }, ()=>{
                obs.error()
                obs.complete()
              })
          }
        } else {
          console.error(data)
          obs.error()
        }
        es.close();
      });
      return () => es.close();
    });
  }

  getDownloadEndPoint(appName:string,serviceName:string){
    if(serviceName==='fca'){
      return  `${(appName == 'fcaapp1') ? ApiEndpoint.fcaapp1 : ApiEndpoint.fcaapp2}/heavy-requests/download`;
    }else{
      return  `${(appName == 'app1') ? ApiEndpoint.app1 : ApiEndpoint.app2}/heavy-requests/download`;
    }
  }
}
